/**
 * Created by yniran on 12/19/14.
 */
define(function (require) {
    "use strict";

    var tmpl = require("tmpl"),
        CP_CONST = require("connection-const"),
        logger = require("logger").getLogger("LEConnection"),


        infoChatBubbleTemplate = require("!raw-loader!connection-templates/chatTab/chatBubbles/infoChatBubble.tmpl"),
        userChatBubbleTemplate = require("!raw-loader!connection-templates/chatTab/chatBubbles/userChatBubble.tmpl"),
        chatBubbleLineTemplate = require("!raw-loader!connection-templates/chatTab/chatBubbles/chatBubbleLine.tmpl");

    var _linePartialTemplate,
        _templateMapping = {};

    function getBubbleHtml(bubbleInfo) {

        var lineType = bubbleInfo.lineType;
        var template = _templateMapping[lineType];
        var html;

        if (template) {
            try {
                html = template(bubbleInfo, { "bubble-line-partial": chatBubbleLineTemplate });
            }
            catch(ex){
                logger.error("failed to render html for chat bubble info", "chatTemplateHelper.getBubbleHtml", bubbleInfo);
                logger.graph({name:"connection:ChatTemplateHelper:getBubbleHtml:fail"});
            }
        }
        else {
            logger.debug("couldn't find a matching bubble template for line type: " + lineType, "chatTemplateHelper.getBubbleHtml");
        }

        return html;
    }

    function getBubbleLinesHtml(bubbleInfo) {

        var html;

        try{
            html = _linePartialTemplate(bubbleInfo);
        }
        catch(ex){
            logger.error("failed to render html for chat lines", "chatTemplateHelper.getBubbleLinesHtml", bubbleInfo);
            logger.graph({name:"connection:ChatTemplateHelper:getBubbleLinesHtml:fail"});
        }

        return html;
    }

    function _init() {

        _linePartialTemplate = tmpl.compile(chatBubbleLineTemplate);

        var cmplInfoChatBubble = tmpl.compile(infoChatBubbleTemplate);
        var cmplUserChatBubble = tmpl.compile(userChatBubbleTemplate);

        var types = CP_CONST.CHAT_LINE_TYPES;

        _templateMapping[types.VISITOR] =
            _templateMapping[types.AGENT] =
                _templateMapping[types.ANOTHER_AGENT] = cmplUserChatBubble;

        _templateMapping[types.INFO] =
            _templateMapping[types.ERROR] = cmplInfoChatBubble;
    }

    _init();

    return {
        getBubbleHtml: getBubbleHtml,
        getBubbleLinesHtml: getBubbleLinesHtml
    };
});
